export const environment = {
  production: true,

  API: 'https://lk5.shineraydobrasil.com.br:8085/api/',
  API_PROTHEUS: 'https://lk5.shineraydobrasil.com.br:8095/rest/',
  authorization: "Basic cG9ydGFsY2xpZW50ZTpQb3J0YWwjMjY=",
  versao: '2.0.31',

  getnetLoaderUrl: 'https://checkout.getnet.com.br/loader.js',
  getnetSellerid: '5d1e8539-f42e-4d05-9194-a138a23d71a1'

};
